import { render } from "./HyperLinksList.vue?vue&type=template&id=6df0e81a"
import script from "./HyperLinksList.vue?vue&type=script&lang=js"
export * from "./HyperLinksList.vue?vue&type=script&lang=js"
script.render = render

export default script